export const getMementoKey = (contextId: string, platform: string) =>
  `sprd-designer-${contextId}-${platform.toLowerCase()}`;
